/**
 * Shared overlay detection for Quasar body scroll-lock management.
 * Kept separate so Mac wheel capture and leaked-lock clearing can share it
 * without circular imports.
 */

/** Matches Navigation.vue `breakpoint` and compact-sidebar (`$q.screen.lt.md`). */
export const DESKTOP_SHELL_MIN_WIDTH = 1024;

/**
 * Active modal/maximized dialogs (not seamless, not closed portal remnants).
 * Prefer `--modal` / `--maximized` over bare `.q-dialog__inner` so we do not
 * treat inert markup as a reason to keep the lock.
 *
 * Do NOT treat `.q-menu` as a body scroll lock — QMenu does not call
 * preventBodyScroll. A false-positive here permanently freezes shell pages
 * whenever a menu portal is mid-transition.
 */
const ACTIVE_DIALOG_SELECTOR =
  '.q-dialog--modal .q-dialog__inner, .q-dialog--maximized .q-dialog__inner';

export function hasRealScrollLockOverlay(root: ParentNode, viewportWidth: number): boolean {
  if (root.querySelector(ACTIVE_DIALOG_SELECTOR)) {
    return true;
  }

  // Desktop sidebar is an in-flow standard drawer, not an overlay.
  if (viewportWidth >= DESKTOP_SHELL_MIN_WIDTH) {
    return false;
  }

  // Mobile overlay drawer: Quasar drops `.hidden` on the backdrop while open.
  return !!root.querySelector('.q-drawer__backdrop:not(.hidden)');
}

export function shouldClearLeakedBodyScrollLock(root: ParentNode, viewportWidth: number): boolean {
  return !hasRealScrollLockOverlay(root, viewportWidth);
}
